import { inject } from '@angular/core';
import {
  TRANSLOCO_FALLBACK_STRATEGY,
  TRANSLOCO_MISSING_HANDLER,
  TranslocoFallbackStrategy,
  TranslocoMissingHandler,
  TranslocoService,
} from '@jsverse/transloco';

export class CustomStrategy implements TranslocoFallbackStrategy {
  getNextLangs(failedLang: string) {
    const fallbackLang: string[] = [];
    if (['nb', 'nn'].includes(failedLang)) {
      fallbackLang.push('no');
    }
    fallbackLang.push('en');
    return fallbackLang;
  }
}

export const customFallbackStrategy = {
  provide: TRANSLOCO_FALLBACK_STRATEGY,
  useClass: CustomStrategy,
};

export class CustomMissingHandler implements TranslocoMissingHandler {
  handle(key: string) {
    if (key.startsWith('INSIGHT.')) {
      return null;
    }
    return key;
  }
}

export const customMissingHandlerStrategy = {
  provide: TRANSLOCO_MISSING_HANDLER,
  useClass: CustomMissingHandler,
};

export class ShowTranslationKeyService {
  private translate = inject(TranslocoService);
  private keysShowing: boolean = false;
  private revertLanguage: string;
  toggleTranslationKeys() {
    if (this.keysShowing) {
      this.translate.setActiveLang(this.revertLanguage);
      this.keysShowing = false;
    } else {
      this.revertLanguage = this.translate.getActiveLang();
      this.translate.setActiveLang('key');
      this.keysShowing = true;
    }
  }
}
